// Runtime config with build-time fallback. Mirrors apps/web's pattern so
// the public forms app picks up the same env vars on the same deploy
// pipeline.
const getRuntimeConfig = () => {
  if (typeof window !== 'undefined' && (window as any).__RUNTIME_CONFIG__) {
    const config = (window as any).__RUNTIME_CONFIG__;
    if (
      config.APP_GRAPHQL_ENDPOINT &&
      !String(config.APP_GRAPHQL_ENDPOINT).includes('__')
    ) {
      return config;
    }
  }
  return {
    APP_ENV: import.meta.env.VITE_APP_ENV,
    APP_GRAPHQL_ENDPOINT: import.meta.env.VITE_APP_GRAPHQL_ENDPOINT,
    APP_TURNSTILE_SITE_KEY: import.meta.env.VITE_APP_TURNSTILE_SITE_KEY,
    APP_MAPBOX_ACCESS_TOKEN: import.meta.env.VITE_APP_MAPBOX_ACCESS_TOKEN,
  };
};

const config = getRuntimeConfig();

export const APP_ENV: 'PROD' | 'DEV' = config.APP_ENV;
export const APP_GRAPHQL_ENDPOINT: string = config.APP_GRAPHQL_ENDPOINT;
// Optional. When unset (or when the docker-entrypoint left the
// placeholder unsubstituted), the public host renders without a
// Turnstile widget regardless of the form's `requireTurnstile` flag —
// useful for local dev without a Cloudflare account.
const rawTurnstileKey = config.APP_TURNSTILE_SITE_KEY;
export const APP_TURNSTILE_SITE_KEY: string | undefined =
  rawTurnstileKey && !String(rawTurnstileKey).includes('__')
    ? rawTurnstileKey
    : undefined;

// Optional Mapbox token for the read-only location block's static map image.
// Unset → the block degrades to an address card + "Open in Maps" link.
const rawMapboxToken = config.APP_MAPBOX_ACCESS_TOKEN;
export const APP_MAPBOX_ACCESS_TOKEN: string | undefined =
  rawMapboxToken && !String(rawMapboxToken).includes('__')
    ? rawMapboxToken
    : undefined;
